<template>

  <section id="universe">

<div class="overflow-protection">
    <b-container fluid>
      <b-row class="header">

        <b-card overlay :img-src="require(`../../assets/images/universe/universebg.jpg`)" img-alt="Universe Background"
          text-variant="white">

          <div class="aspect-ratio"></div>

          <b-card-text class="headline">
            <h1 v-bind:class="{ 'blur': blurheadline}">Control Your <br><span>Universe</span></h1>
            <figcaption class="page-header-description topbottom projectfig">Unilux - Universe App</figcaption>
          </b-card-text>

          <b-row class="main-row" align-h="end">
            <b-col col order="2" order-md="1" cols="12" md="5" lg="4" xl="3" class="main-info">
              <b-card-text class="info-container">

                <h2>Any time, anywhere.</h2>
                <p>Unilux VFC manufactures heating and cooling systems for today’s high-rise condos. With the rising
                  demand for home owners to control their systems remotely, Unilux VFC put the ball in our court to
                  design and develop a solution with a cool look that customers can warm up to. Introducing Universe.
                </p>

              </b-card-text>
            </b-col>


            <b-col col order="1" order-md="2" cols="12" md="6" lg="7" xl="8" class="main-display">
              <parallax breakpoint="(min-width: 992px)">
                <b-img fluid :src="require(`../../assets/images/universe/universehand.png`)"></b-img>
              </parallax>
            </b-col>


          </b-row>

        </b-card>

      </b-row>
    </b-container>


    <b-container fluid class="content-container">

      <b-row class="user-centric justify-content-end">

        <div class="background-box"></div>

        <b-col class="doublephone-container" order="1" order-md="2" cols="12" md="6">
          <b-img class="mobile" fluid :src="require(`../../assets/images/universe/product.png`)"></b-img>

          <b-img class="desktop bottom" fluid :src="require(`../../assets/images/universe/phonebottom.png`)"></b-img>
          <div v-rellax="{ speed: -1.5, center:true }">
            <b-img class="desktop top" fluid :src="require(`../../assets/images/universe/phonetop.png`)"></b-img>
          </div>

        </b-col>

        <b-col class="content-container" order="2" order-md="1" cols="12" md="5">

          <div data-aos="fade-right" class="content">
            <h3>User-Centric,<br class="sm-only"> Intuitive <br class="md-up"><span>Design</span></h3>
            <p>Through competitive analysis and testing, we designed a unique user experience that put home owners’ comfort in the palm of their hand. The Universe mobile app became such a hit, that home owners preferred using it instead of their wall-mounted thermostat to control their home's heating and cooling.</p>
          </div>


        </b-col>
        <div class="bg-lrg"></div>

      </b-row>


      <b-row class="simplified-interface">
        <b-row class='simplified-interface-max justify-content-center'>
          <b-col order-sm="1" order-md="1" order-lg="2" col cols="12" class="small-title">
            <h3 data-aos="fade-left">A simplified interface that users&nbsp;

              <svg class="heart" width="20" height="20" viewBox="0 0 100 100">
                <path fill="tomato"
                  d="M92.71,7.27L92.71,7.27c-9.71-9.69-25.46-9.69-35.18,0L50,14.79l-7.54-7.52C32.75-2.42,17-2.42,7.29,7.27v0 c-9.71,9.69-9.71,25.41,0,35.1L50,85l42.71-42.63C102.43,32.68,102.43,16.96,92.71,7.27z">
                </path>
                <animateTransform attributeName="transform" type="scale" values="1; 1.5; 1.25; 1.5; 1.5; 1;" dur="1s"
                  repeatCount="indefinite">
                </animateTransform>
              </svg>
            </h3>
          </b-col>

          <b-col class="centercontent" order-sm="2" order-md="2" order-lg="1" col cols="12" md="5" lg="5">
            <!-- <b-img data-aos="fade-right" class="console" fluid :src="require(`../../assets/images/universe/suniverse-gaugesd.svg`)"></b-img> -->

            <svg class="console" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 322.996 380.129">
              <defs>
                <linearGradient id="linear-gradient" x1="0.499" y1="0.999" x2="0.499" y2="-0.001"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#1d1d1d" />
                  <stop offset="1" stop-color="#454545" />
                </linearGradient>
                <linearGradient id="linear-gradient-2" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#434343" />
                  <stop offset="1" stop-color="#1d1d1d" />
                </linearGradient>
                <linearGradient id="linear-gradient-3" x1="0.5" y1="-0.015" x2="0.491" y2="0.878"
                  xlink:href="#linear-gradient-2" />
                <linearGradient id="linear-gradient-4" x1="0.5" y1="0.999" x2="0.5" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#424242" />
                  <stop offset="1" stop-color="#1e1e1e" />
                </linearGradient>
                <linearGradient id="linear-gradient-5" x1="0.499" y1="1" x2="0.499" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#1f1f1f" />
                  <stop offset="1" stop-color="#434343" />
                </linearGradient>
                <linearGradient id="linear-gradient-6" x1="0.5" y1="0.031" x2="0.533" y2="1.177"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#1e1e1e" />
                  <stop offset="1" stop-color="#434343" />
                </linearGradient>
                <linearGradient id="linear-gradient-7" x1="0.499" y1="1.001" x2="0.499" y2="0.001"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#434343" />
                  <stop offset="1" stop-color="#1e1e1e" />
                </linearGradient>
                <linearGradient id="linear-gradient-8" x1="0.5" y1="0.002" x2="0.5" y2="1"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#242424" />
                  <stop offset="1" stop-color="#333" />
                </linearGradient>
                <linearGradient id="linear-gradient-9" x1="0.498" y1="-0.03" x2="0.498" y2="1.045"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#343434" />
                  <stop offset="1" stop-color="#171717" />
                </linearGradient>
                <linearGradient id="linear-gradient-10" x1="0.493" y1="1.167" x2="0.493" y2="-0.214"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#ed1c24" />
                  <stop offset="0.117" stop-color="#ef3023" />
                  <stop offset="0.393" stop-color="#f25b21" />
                  <stop offset="0.641" stop-color="#f57a1f" />
                  <stop offset="0.852" stop-color="#f68c1e" />
                  <stop offset="1" stop-color="#f7931e" />
                </linearGradient>
                <linearGradient id="linear-gradient-13" x1="0.498" y1="-0.03" x2="0.498" y2="1.045"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#464646" />
                  <stop offset="1" stop-color="#5b5b5b" />
                </linearGradient>
                <linearGradient id="linear-gradient-18" x1="0.493" y1="1.211" x2="0.493" y2="-0.28"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#0071bc" />
                  <stop offset="1" stop-color="#29abe2" />
                </linearGradient>
                <linearGradient id="linear-gradient-21" x1="0.498" y1="-0.03" x2="0.498" y2="1.045"
                  gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#454545" />
                  <stop offset="1" stop-color="#5c5c5c" />
                </linearGradient>
              </defs>
              <g id="MainConsole" transform="translate(-952.125 -4140.738)">
                <g id="Shell" transform="translate(-84 -26)">
                  <g id="Group_179" data-name="Group 179" transform="translate(1258.016 4169.316)">
                    <g id="Group_178" data-name="Group 178">
                      <ellipse id="Ellipse_15" data-name="Ellipse 15" cx="50.552" cy="50.552" rx="50.552" ry="50.552"
                        fill="url(#linear-gradient)" />
                    </g>
                    <ellipse id="Ellipse_16" data-name="Ellipse 16" cx="43.238" cy="43.238" rx="43.238" ry="43.238"
                      transform="translate(7.744 7.314)" fill="#fff" stroke="#4e4e4e" stroke-miterlimit="10"
                      stroke-width="1.5" />
                    <ellipse id="Ellipse_17" data-name="Ellipse 17" cx="43.238" cy="43.238" rx="43.238" ry="43.238"
                      transform="translate(7.744 7.314)" fill="#262626" stroke="#4e4e4e" stroke-miterlimit="10"
                      stroke-width="0.5" />
                  </g>
                  <!-- <path id="Path_214" data-name="Path 214" d="M178.631,130.08c-4.733,0-9.465.215-13.983.645-8.82.86-16.134-6.884-14.2-15.488a77.824,77.824,0,0,0,1.721-21.3,70.336,70.336,0,1,0-91.64,72.279c8.39,2.8,12.047,12.907,6.669,20.006a137.142,137.142,0,0,0-27.1,86.262c1.936,73.785,62.6,133.8,136.6,134.878,77.442,1.076,140.686-61.308,140.686-138.535C317.166,192.248,255.212,130.08,178.631,130.08Z" transform="translate(1025.3 4138.613)" fill="none" stroke="#1f1f1f" stroke-miterlimit="10" stroke-width="1.75"/> -->
                  <path id="Path_215" data-name="Path 215"
                    d="M178.631,130.08c-4.733,0-9.465.215-13.983.645-8.82.86-16.134-6.884-14.2-15.488a77.824,77.824,0,0,0,1.721-21.3,70.336,70.336,0,1,0-91.64,72.279c8.39,2.8,12.047,12.907,6.669,20.006a137.142,137.142,0,0,0-27.1,86.262c1.936,73.785,62.6,133.8,136.6,134.878,77.442,1.076,140.686-61.308,140.686-138.535C317.166,192.248,255.212,130.08,178.631,130.08Z"
                    transform="translate(1027.396 4138.613)" stroke="#191818" stroke-miterlimit="10" stroke-width="1"
                    fill="url(#linear-gradient-2)" />
                  <g id="Group_184" data-name="Group 184" transform="translate(1080.613 4281.815)">
                    <path id="Path_274" data-name="Path 274"
                      d="M125.413,0A125.413,125.413,0,1,1,0,125.413,125.413,125.413,0,0,1,125.413,0Z"
                      fill="url(#linear-gradient-3)" />
                    <path id="Path_217" data-name="Path 217"
                      d="M156.413,86.5a121.111,121.111,0,1,1,0,242.221C89.512,328.724,35.3,274.3,35.3,207.4S89.727,86.5,156.413,86.5m0-4.3A125.413,125.413,0,1,0,281.826,207.613C281.611,138.346,225.681,82.2,156.413,82.2Z"
                      transform="translate(-31 -81.985)" fill="url(#linear-gradient-4)" />
                  </g>
                  <path id="Path_218" data-name="Path 218"
                    d="M145.349,228.832H155.89c39.151.86,73.355,11.186,94.436,26.674A112.094,112.094,0,0,0,264.094,201.3a113.8,113.8,0,0,0-227.594,0,115.413,115.413,0,0,0,13.983,54.855C71.564,240.448,105.983,229.907,145.349,228.832Z"
                    transform="translate(1055.945 4208.961)" fill="#262626" stroke="#4b4b4b" stroke-miterlimit="10"
                    stroke-width="0.5" />
                  <g id="Group_192" data-name="Group 192" transform="translate(1050.497 4179.204)">
                    <ellipse id="Ellipse_21" data-name="Ellipse 21" cx="58.727" cy="58.727" rx="58.727" ry="58.727"
                      transform="translate(0.215)" fill="url(#linear-gradient-5)" />
                    <g id="Group_191" data-name="Group 191">
                      <path id="Path_225" data-name="Path 225"
                        d="M75.942,36.551A56.576,56.576,0,1,1,19.151,93.127,56.645,56.645,0,0,1,75.942,36.551m0-2.151a58.727,58.727,0,1,0,58.727,58.727A58.848,58.848,0,0,0,75.942,34.4Z"
                        transform="translate(-17 -34.4)" fill="url(#linear-gradient-6)" />
                    </g>
                  </g>
                  <ellipse id="Ellipse_22" data-name="Ellipse 22" cx="51.628" cy="51.628" rx="51.628" ry="51.628"
                    transform="translate(1057.811 4186.303)" fill="#262626" stroke="#2b2b2b" stroke-miterlimit="10"
                    stroke-width="0.5" />
                </g>
                <g id="OutdoorConsole">
                  <ellipse id="Ellipse_57" data-name="Ellipse 57" cx="43.238" cy="43.238" rx="43.238" ry="43.238"
                    transform="translate(1181.76 4150.63)" fill="#262626" stroke="#4e4e4e" stroke-miterlimit="10"
                    stroke-width="0.5" />
                  <text id="OUTDOOR" transform="translate(1207.885 4179.741)" fill="#fff" font-size="7"
                    font-family="Helvetica">
                    <tspan x="0" y="0">OUTDOOR</tspan>
                  </text>
                  <text id="_28" text-anchor="middle" data-name="28" transform="translate(1191.056 4187.864)"
                    fill="#fff" font-size="28" font-family="Helvetica">
                    <tspan x="34" y="23" v-html="1.5"></tspan>
                  </text>
                </g>
                <g id="Up" @mousedown="start('up')" @mouseup="stop('up')" @touchstart="start('up')"
                  @touchend="stop('up')" @touchcancel="stop('up')">
                  <g id="TempUp" transform="translate(1059.878 4421.065)">
                    <g id="Group_185" data-name="Group 185" transform="translate(-3)">
                      <path id="Path_219" data-name="Path 219"
                        d="M87.087,218.073a30.087,30.087,0,1,1,30.087-30.087A30.125,30.125,0,0,1,87.087,218.073Zm0-57.666a27.772,27.772,0,1,0,27.772,27.772A27.779,27.779,0,0,0,87.087,160.407Z"
                        transform="translate(-57 -157.9)" fill="url(#linear-gradient-7)" />
                    </g>
                    <g id="Group_186" data-name="Group 186" transform="translate(-0.879 2.122)">
                      <path id="Path_220" data-name="Path 220"
                        d="M86.065,214.93a27.966,27.966,0,1,1,27.772-27.965A27.985,27.985,0,0,1,86.065,214.93Zm0-53.616a25.651,25.651,0,1,0,25.651,25.651A25.764,25.764,0,0,0,86.065,161.314Z"
                        transform="translate(-58.1 -159)" fill="url(#linear-gradient-8)" />
                    </g>
                    <ellipse id="Ellipse_19" data-name="Ellipse 19" cx="26.808" cy="26.808" rx="26.808" ry="26.808"
                      transform="translate(0.279 3.279)" stroke="#343434" stroke-miterlimit="10" stroke-width="0.5"
                      fill="url(#linear-gradient-9)" />
                    <path id="Path_221" data-name="Path 221" d="M69.5,188.732,79.851,170.7,90.2,188.732Z"
                      transform="translate(-53.089 -149.771)" fill="url(#linear-gradient-10)" />
                  </g>
                  <g id="TempUpPressed" v-if="tempupPressed" transform="translate(1059.878 4421.065)">
                    <g id="Group_185-2" data-name="Group 185" transform="translate(-3)">
                      <path id="Path_219-2" data-name="Path 219"
                        d="M87.087,218.073a30.087,30.087,0,1,1,30.087-30.087A30.125,30.125,0,0,1,87.087,218.073Zm0-57.666a27.772,27.772,0,1,0,27.772,27.772A27.779,27.779,0,0,0,87.087,160.407Z"
                        transform="translate(-57 -157.9)" fill="url(#linear-gradient-7)" />
                    </g>
                    <g id="Group_186-2" data-name="Group 186" transform="translate(-0.879 2.122)">
                      <path id="Path_220-2" data-name="Path 220"
                        d="M86.065,214.93a27.966,27.966,0,1,1,27.772-27.965A27.985,27.985,0,0,1,86.065,214.93Zm0-53.616a25.651,25.651,0,1,0,25.651,25.651A25.764,25.764,0,0,0,86.065,161.314Z"
                        transform="translate(-58.1 -159)" fill="url(#linear-gradient-8)" />
                    </g>
                    <ellipse id="Ellipse_19-2" data-name="Ellipse 19" cx="26.808" cy="26.808" rx="26.808" ry="26.808"
                      transform="translate(0.279 3.279)" stroke="#343434" stroke-miterlimit="10" stroke-width="0.5"
                      fill="url(#linear-gradient-13)" />
                    <path id="Path_221-2" data-name="Path 221" d="M69.5,188.732,79.851,170.7,90.2,188.732Z"
                      transform="translate(-53.089 -149.771)" fill="url(#linear-gradient-10)" />
                  </g>
                </g>
                <g id="Down" @mousedown="start('down')" @mouseup="stop('down')" @touchstart="start('down')"
                  @touchend="stop('down')" @touchcancel="stop('down')">
                  <g id="TempDown" transform="translate(1129.104 4421.065)">
                    <g id="Group_185-3" data-name="Group 185" transform="translate(1)">
                      <path id="Path_219-3" data-name="Path 219"
                        d="M87.087,218.073a30.087,30.087,0,1,1,30.087-30.087A30.125,30.125,0,0,1,87.087,218.073Zm0-57.666a27.772,27.772,0,1,0,27.772,27.772A27.779,27.779,0,0,0,87.087,160.407Z"
                        transform="translate(-57 -157.9)" fill="url(#linear-gradient-7)" />
                    </g>
                    <g id="Group_186-3" data-name="Group 186" transform="translate(3.121 2.122)">
                      <path id="Path_220-3" data-name="Path 220"
                        d="M86.065,214.93a27.966,27.966,0,1,1,27.772-27.965A27.985,27.985,0,0,1,86.065,214.93Zm0-53.616a25.651,25.651,0,1,0,25.651,25.651A25.764,25.764,0,0,0,86.065,161.314Z"
                        transform="translate(-58.1 -159)" fill="url(#linear-gradient-8)" />
                    </g>
                    <ellipse id="Ellipse_19-3" data-name="Ellipse 19" cx="26.808" cy="26.808" rx="26.808" ry="26.808"
                      transform="translate(4.279 3.279)" stroke="#343434" stroke-miterlimit="10" stroke-width="0.5"
                      fill="url(#linear-gradient-9)" />
                    <path id="Path_275" data-name="Path 275" d="M125.206,171.4l-10.7,18.644L103.8,171.4Z"
                      transform="translate(-83.437 -150.174)" fill="url(#linear-gradient-18)" />
                  </g>
                  <g id="TempDownPressed" v-if="tempdownPressed" transform="translate(1129.104 4421.065)">
                    <g id="Group_185-4" data-name="Group 185" transform="translate(1)">
                      <path id="Path_219-4" data-name="Path 219"
                        d="M87.087,218.073a30.087,30.087,0,1,1,30.087-30.087A30.125,30.125,0,0,1,87.087,218.073Zm0-57.666a27.772,27.772,0,1,0,27.772,27.772A27.779,27.779,0,0,0,87.087,160.407Z"
                        transform="translate(-57 -157.9)" fill="url(#linear-gradient-7)" />
                    </g>
                    <g id="Group_186-4" data-name="Group 186" transform="translate(3.121 2.122)">
                      <path id="Path_220-4" data-name="Path 220"
                        d="M86.065,214.93a27.966,27.966,0,1,1,27.772-27.965A27.985,27.985,0,0,1,86.065,214.93Zm0-53.616a25.651,25.651,0,1,0,25.651,25.651A25.764,25.764,0,0,0,86.065,161.314Z"
                        transform="translate(-58.1 -159)" fill="url(#linear-gradient-8)" />
                    </g>
                    <ellipse id="Ellipse_19-4" data-name="Ellipse 19" cx="26.808" cy="26.808" rx="26.808" ry="26.808"
                      transform="translate(4.279 3.279)" stroke="#343434" stroke-miterlimit="10" stroke-width="0.5"
                      fill="url(#linear-gradient-21)" />
                    <path id="Path_275-2" data-name="Path 275" d="M125.206,171.4l-10.7,18.644L103.8,171.4Z"
                      transform="translate(-83.437 -150.174)" fill="url(#linear-gradient-18)" />
                  </g>
                </g>
                <g id="IndoorConsole">
                  <ellipse id="Ellipse_56" data-name="Ellipse 56" cx="51.628" cy="51.628" rx="51.628" ry="51.628"
                    transform="translate(973.811 4160.303)" fill="#262626" stroke="#2b2b2b" stroke-miterlimit="10"
                    stroke-width="0.5" />
                  <text id="_22" text-anchor="middle" data-name="22" transform="translate(976.895 4193.51)" fill="#fff"
                    font-size="37" font-family="Helvetica">
                    <tspan x="47" y="32" v-html="22"></tspan>
                  </text>
                  <text id="_22" text-anchor="middle" data-name="22" transform="translate(976.895 4193.51)" fill="#fff"
                    font-size="17" font-family="Helvetica">
                    <tspan x="73" y="18" v-if="indoortemp_decimal">.5</tspan>
                  </text>
                  <text id="INDOOR" transform="translate(1011.304 4187.792)" fill="#fff" font-size="7"
                    font-family="Helvetica">
                    <tspan x="0" y="0">INDOOR</tspan>
                  </text>
                  <text id="_36_" text-anchor="middle" data-name="36%" transform="translate(978.895 4233.079)"
                    fill="#9d9d9d" font-size="13" font-family="Helvetica">
                    <tspan x="50" y="12">46%</tspan>
                  </text>
                </g>
                <g id="TempConsole">
                  <path id="Path_316" data-name="Path 316"
                    d="M145.349,228.832H155.89c39.151.86,73.355,11.186,94.436,26.674A112.094,112.094,0,0,0,264.094,201.3a113.8,113.8,0,0,0-227.594,0,115.413,115.413,0,0,0,13.983,54.855C71.564,240.448,105.983,229.907,145.349,228.832Z"
                    transform="translate(971.945 4182.961)" fill="#262626" stroke="#4b4b4b" stroke-miterlimit="10"
                    stroke-width="0.5" />
                  <text id="_12:07_PM" text-anchor="middle" data-name="12:07 PM"
                    transform="translate(1043.596 4290.799)" fill="#fff" font-size="12" font-family="Helvetica">
                    <tspan x="80" y="14">12:30 PM</tspan>
                  </text>
                  <text id="_212" text-anchor="middle" data-name="212" transform="translate(1011.258 4311.614)"
                    fill="#87bae4" font-size="65" font-family="Helvetica" font-weight="300" opacity="0.812">
                    <tspan x="110" y="56"
                      v-html="tempCalculatorwithFormat(currentDevice.online_settings.units, (currentDevice.online_settings.units == 0) ? tempControl.hold_temp.celsius : tempControl.hold_temp.fahrenheit, 'holdtemp_decimal')">
                    </tspan>
                  </text>
                  <text id="_212" text-anchor="middle" data-name="212" transform="translate(1011.258 4311.614)"
                    fill="#87bae4" font-size="25" font-family="Helvetica" font-weight="300" opacity="0.812">
                    <tspan x="157" y="29" v-if='holdtemp_decimal'>.5</tspan>
                  </text>
                  <g id="Mode" transform="translate(-352 56)">
                    <g id="CoolMode" v-if="!tempControl.mode.cool" transform="translate(-2 32.079)">
                      <path id="Path_314" data-name="Path 314"
                        d="M47.476,239.314l2.272-1.326c.189-.189.379-.568.189-.757s-.568-.379-.757-.189l-2.841,1.7-3.409-1.894,3.409-1.894,2.841,1.7h.379c.189,0,.379-.189.568-.379s0-.568-.189-.758L47.666,234.2l3.977-2.273c.189-.189.379-.568.189-.758s-.568-.379-.757-.189L47.1,233.254V230.6a.5.5,0,0,0-.568-.568h0a.5.5,0,0,0-.568.568v3.219l-3.409,1.894v-3.977l2.841-1.7c.189-.189.379-.568.189-.757s-.568-.379-.757-.189l-2.272,1.326v-4.545a.568.568,0,0,0-1.136,0v4.545l-2.272-1.326c-.189-.189-.568,0-.757.189s0,.568.189.757l2.841,1.7v3.977l-3.409-1.894V230.6a.5.5,0,0,0-.568-.568h0a.5.5,0,0,0-.568.568v2.651l-3.977-2.272c-.189-.189-.568,0-.758.189s0,.568.189.758L36.3,234.2l-2.272,1.326c-.189.189-.379.568-.189.758s.379.379.568.379h.379l2.841-1.7,3.409,1.894-3.409,1.894-2.841-1.7c-.189-.189-.568,0-.757.189s0,.568.189.757l2.272,1.326-3.977,2.273c-.189.189-.379.568-.189.757s.379.379.568.379h.379l3.977-2.273V243.1a.5.5,0,0,0,.568.568.6.6,0,0,0,.568-.568v-3.219l3.409-1.894v3.977l-2.841,1.7c-.189.189-.379.568-.189.758s.568.379.758.189l2.272-1.326v4.545a.568.568,0,1,0,1.136,0v-4.545l2.272,1.326h.189c.189,0,.379-.189.568-.379s0-.568-.189-.758l-2.841-1.7V237.8l3.409,1.894v3.219a.5.5,0,0,0,.568.568h0a.5.5,0,0,0,.568-.568v-2.651l3.977,2.273h.379c.189,0,.379-.189.568-.379s0-.568-.189-.757Z"
                        transform="translate(1396.941 4069.621)" fill="#acacac" />
                    </g>
                    <g id="HeatMode" transform="translate(1430 4328)">
                      <path id="Path_203" data-name="Path 203"
                        d="M3.889,22.181C1.423,14.056,6.633,11.09,6.633,11.09a12.564,12.564,0,0,0,2.1,7.713,13.258,13.258,0,0,0,2.636-1.551,28.15,28.15,0,0,1-.913,4.928,13.034,13.034,0,0,0,4.2-6.573c1-4.1-1.913-8.222-1.913-8.222a11,11,0,0,1-2.731,7.942,1.574,1.574,0,0,0,.239-.368c.346-.692.9-2.489.576-6.651C10.369,2.464,5.075,0,5.075,0,5.531,3.56,4.163,4.38.958,11.138S3.889,22.181,3.889,22.181Zm0,0"
                        transform="translate(-0.031 0)" fill="#acacac" />
                    </g>
                    <g id="AutoMode" v-if="!tempControl.mode.auto" transform="translate(1427 4328)">
                      <g id="fire" transform="translate(9.048 6.279)">
                        <path id="Path_203-2" data-name="Path 203"
                          d="M2.839,16.146c-1.795-5.914,2-8.074,2-8.074a9.145,9.145,0,0,0,1.528,5.614,9.651,9.651,0,0,0,1.919-1.129,20.49,20.49,0,0,1-.664,3.587,9.487,9.487,0,0,0,3.058-4.785c.731-2.986-1.393-5.985-1.393-5.985A8.008,8.008,0,0,1,7.3,11.156a1.146,1.146,0,0,0,.174-.268c.252-.5.656-1.812.419-4.842A7.737,7.737,0,0,0,3.7,0c.332,2.591-.664,3.188-3,8.107S2.839,16.146,2.839,16.146Zm0,0"
                          transform="translate(-0.031 0)" fill="#acacac" />
                      </g>
                      <path id="Path_315" data-name="Path 315"
                        d="M12.067,9.971,9.637,8.592l1.389-.784a.316.316,0,0,0,.126-.439.321.321,0,0,0-.442-.125l-1.7.972L6.8,6.961,8.911,5.77,10.742,6.8a.286.286,0,0,0,.158.031.332.332,0,0,0,.284-.157.316.316,0,0,0-.126-.439L9.574,5.393,12.1,3.951a.316.316,0,0,0,.126-.439.286.286,0,0,0-.41-.125L9.195,4.86V3.136c0-.188-.253-.314-.41-.314s-.41.157-.41.314v2.1L6.354,6.428V3.951l1.957-1.1a.316.316,0,0,0,.126-.439A.321.321,0,0,0,8,2.289L6.354,3.23V.314C6.354.125,6.259,0,6.07,0a.289.289,0,0,0-.284.314V3.136L4.3,2.289a.321.321,0,0,0-.442.125.316.316,0,0,0,.126.439l1.8,1.035V6.365L3.8,5.142V3.136c0-.188-.253-.314-.41-.314s-.41.157-.41.314v1.6L.545,3.355A.321.321,0,0,0,.1,3.481.316.316,0,0,0,.23,3.92L2.755,5.362,1.24,6.24a.316.316,0,0,0-.126.439.332.332,0,0,0,.284.157A.286.286,0,0,0,1.556,6.8L3.386,5.738,5.5,6.961,3.26,8.247l-1.736-1a.321.321,0,0,0-.442.125.316.316,0,0,0,.126.439l1.421.815L.23,10a.316.316,0,0,0-.126.439.332.332,0,0,0,.284.157.238.238,0,0,0,.158-.031l2.431-1.38v1.474c0,.188.253.314.41.314s.41-.157.41-.314V8.874s-.095-.031-.063-.031V8.748L5.786,7.557V9.971l-1.8,1a.316.316,0,0,0-.126.439.332.332,0,0,0,.284.157.4.4,0,0,0,.189-.031l1.484-.847v2.885c0,.188.095.314.284.314a.289.289,0,0,0,.284-.314V10.6L8,11.508a.345.345,0,0,0,.158.031.332.332,0,0,0,.284-.157.316.316,0,0,0-.126-.439l-1.957-1.1V7.431L8.406,8.623s-.063,0-.063.031v2.007c0,.188.253.314.41.314s.41-.157.41-.314V9.031l2.588,1.505a.286.286,0,0,0,.158.031.332.332,0,0,0,.284-.157A.316.316,0,0,0,12.067,9.971Z"
                        transform="translate(-0.059)" fill="#acacac" />
                    </g>
                    <g id="OffMode" v-if="!tempControl.mode.off" transform="translate(1431 4331.349)">
                      <g id="Group_68" data-name="Group 68">
                        <path id="Path_171" data-name="Path 171"
                          d="M48.281,60.579s-.969-.436-.969.579a2.289,2.289,0,0,0,.974,1.691,6.068,6.068,0,1,1-6.46.005,2.306,2.306,0,0,0,.974-1.691c0-1.015-.969-.579-.969-.579a8.068,8.068,0,1,0,6.453-.005Z"
                          transform="translate(-36.998 -58.016)" fill="#acacac" />
                        <path id="Path_172" data-name="Path 172"
                          d="M172.685,12.3a1.074,1.074,0,0,0-1.185.912v8.047a1.074,1.074,0,0,0,1.185.912.948.948,0,0,0,1.072-.912V13.217A.949.949,0,0,0,172.685,12.3Z"
                          transform="translate(-164.57 -12.3)" fill="#acacac" />
                      </g>
                    </g>
                  </g>
                  <g id="Fan" transform="translate(-360 41)">
                    <g id="FanMed" v-if="!tempControl.fan.med" transform="translate(1477 4343)">
                      <path id="Path_207" data-name="Path 207"
                        d="M87.519,247.3a1.619,1.619,0,1,0,1.619,1.619A1.735,1.735,0,0,0,87.519,247.3Z"
                        transform="translate(-85.9 -229.539)" fill="#acacac" />
                      <path id="Path_208" data-name="Path 208"
                        d="M91.319,247.3a1.619,1.619,0,1,0,1.619,1.619A1.735,1.735,0,0,0,91.319,247.3Z"
                        transform="translate(-83.547 -229.539)" fill="#acacac" />
                      <g id="Group_171" data-name="Group 171" transform="translate(0.255)">
                        <ellipse id="Ellipse_11" data-name="Ellipse 11" cx="1.133" cy="1.133" rx="1.133" ry="1.133"
                          transform="translate(6.707 6.588)" fill="#acacac" />
                        <g id="Group_170" data-name="Group 170">
                          <path id="Path_209" data-name="Path 209"
                            d="M90.9,241.462h.324a2.626,2.626,0,0,1,2.591,2.1c1.781-.81,3.076-2.1,2.591-4.21-.486-2.267-3.238-3.4-4.534-2.915-1.457.486-1.781,1.781-1.3,3.238A4.53,4.53,0,0,1,90.9,241.462Z"
                            transform="translate(-83.387 -236.331)" fill="#acacac" />
                          <path id="Path_210" data-name="Path 210"
                            d="M91.308,242.262a2.308,2.308,0,0,1,.972-1.943c-1.619-1.3-3.562-1.619-5.181,0a4.165,4.165,0,0,0,0,5.505,2.275,2.275,0,0,0,3.4-.648,3.15,3.15,0,0,1,1.3-1.3A2.736,2.736,0,0,1,91.308,242.262Z"
                            transform="translate(-86.058 -234.541)" fill="#acacac" />
                          <path id="Path_211" data-name="Path 211"
                            d="M95.416,242.286a6.273,6.273,0,0,1-1.781-.486,2.792,2.792,0,0,1-2.429,1.457,2.054,2.054,0,0,1-.972-.162c-.324,1.943.162,3.724,2.429,4.372a3.993,3.993,0,0,0,4.858-2.591A2.161,2.161,0,0,0,95.416,242.286Z"
                            transform="translate(-83.527 -232.945)" fill="#acacac" />
                        </g>
                      </g>
                    </g>
                    <g id="FanLow" v-if="!tempControl.fan.low" transform="translate(1478 4343)">
                      <path id="Path_207-2" data-name="Path 207"
                        d="M87.477,247.3a1.577,1.577,0,1,0,1.577,1.577A1.69,1.69,0,0,0,87.477,247.3Z"
                        transform="translate(-85.9 -230.001)" fill="#acacac" />
                      <g id="Group_171-2" data-name="Group 171" transform="translate(0.249)">
                        <ellipse id="Ellipse_11-2" data-name="Ellipse 11" cx="1.104" cy="1.104" rx="1.104" ry="1.104"
                          transform="translate(6.533 6.417)" fill="#acacac" />
                        <g id="Group_170-2" data-name="Group 170">
                          <path id="Path_209-2" data-name="Path 209"
                            d="M90.89,241.329h.315a2.558,2.558,0,0,1,2.523,2.05c1.735-.789,3-2.05,2.523-4.1-.473-2.208-3.154-3.312-4.416-2.839-1.419.473-1.735,1.735-1.262,3.154A4.412,4.412,0,0,1,90.89,241.329Z"
                            transform="translate(-83.569 -236.331)" fill="#acacac" />
                          <path id="Path_210-2" data-name="Path 210"
                            d="M91.171,242.183a2.248,2.248,0,0,1,.946-1.893c-1.577-1.262-3.47-1.577-5.047,0a4.057,4.057,0,0,0,0,5.362,2.216,2.216,0,0,0,3.312-.631,3.068,3.068,0,0,1,1.262-1.262A2.664,2.664,0,0,1,91.171,242.183Z"
                            transform="translate(-86.058 -234.663)" fill="#acacac" />
                          <path id="Path_211-2" data-name="Path 211"
                            d="M95.279,242.273a6.11,6.11,0,0,1-1.735-.473,2.72,2.72,0,0,1-2.366,1.419,2,2,0,0,1-.946-.158c-.315,1.893.158,3.627,2.366,4.258a3.889,3.889,0,0,0,4.731-2.523A2.1,2.1,0,0,0,95.279,242.273Z"
                            transform="translate(-83.699 -233.175)" fill="#acacac" />
                        </g>
                      </g>
                    </g>
                    <g id="FanAuto" transform="translate(1476 4344)">
                      <g id="Group_74" data-name="Group 74" transform="translate(0 0)">
                        <path id="Path_137" data-name="Path 137"
                          d="M8.6,16.774A6.872,6.872,0,0,1,1.69,9.91,7.044,7.044,0,0,1,3.331,5.416l.646.988L5.816,2.7,1.69,3l.7,1.037A8.345,8.345,0,0,0,0,9.91a8.575,8.575,0,0,0,8.6,8.543.835.835,0,0,0,.845-.839A.867.867,0,0,0,8.6,16.774Z"
                          transform="translate(0 -1.367)" fill="#acacac" />
                        <path id="Path_138" data-name="Path 138"
                          d="M25,8.543A8.532,8.532,0,0,0,16.445,0,.835.835,0,0,0,15.6.839a.806.806,0,0,0,.845.839,6.872,6.872,0,0,1,6.91,6.864,6.7,6.7,0,0,1-1.541,4.3l-.7-.938-1.69,3.753,4.126-.4-.746-.988A8.863,8.863,0,0,0,25,8.543Z"
                          transform="translate(-7.845 0)" fill="#acacac" />
                        <g id="Group_169" data-name="Group 169" transform="translate(9.469 2.04) rotate(50)">
                          <path id="Path_199" data-name="Path 199"
                            d="M.686,0a.68.68,0,0,1,.682.683.689.689,0,0,1-.686.686A.68.68,0,0,1,0,.686.689.689,0,0,1,.686,0Z"
                            transform="translate(3.89 3.802)" fill="#acacac" />
                          <g id="Group_64" data-name="Group 64" transform="translate(0 0)">
                            <path id="Path_167" data-name="Path 167"
                              d="M.374,2.986c.047,0,.094-.019.141-.019A1.5,1.5,0,0,1,2,4.229,2.055,2.055,0,0,0,3.517,1.778,2.281,2.281,0,0,0,.878.068a1.288,1.288,0,0,0-.736,1.85A2.383,2.383,0,0,1,.374,2.986Z"
                              transform="translate(4.054 0)" fill="#acacac" />
                            <path id="Path_168" data-name="Path 168"
                              d="M3.056,1.788A1.515,1.515,0,0,1,3.612.624c-.982-.71-2.05-.951-3,.017A2.309,2.309,0,0,0,.634,3.8a1.3,1.3,0,0,0,1.95-.418,2.619,2.619,0,0,1,.723-.752A1.535,1.535,0,0,1,3.056,1.788Z"
                              transform="translate(0 2.702)" fill="#acacac" />
                            <path id="Path_169" data-name="Path 169"
                              d="M2.972.307A2.594,2.594,0,0,1,1.97,0,1.526,1.526,0,0,1,.6.885,1.429,1.429,0,0,1,.038.774,2.04,2.04,0,0,0,1.409,3.312a2.32,2.32,0,0,0,2.806-1.47A1.273,1.273,0,0,0,2.972.307Z"
                              transform="translate(3.971 5.13)" fill="#acacac" />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="FanHigh" v-if="!tempControl.fan.high" transform="translate(1477 4343)">
                      <path id="Path_207-3" data-name="Path 207"
                        d="M87.477,247.3a1.577,1.577,0,1,0,1.577,1.577A1.69,1.69,0,0,0,87.477,247.3Z"
                        transform="translate(-85.9 -230.001)" fill="#acacac" />
                      <path id="Path_208-2" data-name="Path 208"
                        d="M91.277,247.3a1.577,1.577,0,1,0,1.577,1.577A1.69,1.69,0,0,0,91.277,247.3Z"
                        transform="translate(-83.707 -230.001)" fill="#acacac" />
                      <g id="Group_171-3" data-name="Group 171" transform="translate(0.249)">
                        <ellipse id="Ellipse_11-3" data-name="Ellipse 11" cx="1.104" cy="1.104" rx="1.104" ry="1.104"
                          transform="translate(6.533 6.417)" fill="#acacac" />
                        <g id="Group_170-3" data-name="Group 170">
                          <path id="Path_209-3" data-name="Path 209"
                            d="M90.89,241.329h.315a2.558,2.558,0,0,1,2.523,2.05c1.735-.789,3-2.05,2.523-4.1-.473-2.208-3.154-3.312-4.416-2.839-1.419.473-1.735,1.735-1.262,3.154A4.412,4.412,0,0,1,90.89,241.329Z"
                            transform="translate(-83.569 -236.331)" fill="#acacac" />
                          <path id="Path_210-3" data-name="Path 210"
                            d="M91.171,242.183a2.248,2.248,0,0,1,.946-1.893c-1.577-1.262-3.47-1.577-5.047,0a4.057,4.057,0,0,0,0,5.362,2.216,2.216,0,0,0,3.312-.631,3.068,3.068,0,0,1,1.262-1.262A2.664,2.664,0,0,1,91.171,242.183Z"
                            transform="translate(-86.058 -234.663)" fill="#acacac" />
                          <path id="Path_211-3" data-name="Path 211"
                            d="M95.279,242.273a6.11,6.11,0,0,1-1.735-.473,2.72,2.72,0,0,1-2.366,1.419,2,2,0,0,1-.946-.158c-.315,1.893.158,3.627,2.366,4.258a3.889,3.889,0,0,0,4.731-2.523A2.1,2.1,0,0,0,95.279,242.273Z"
                            transform="translate(-83.699 -233.175)" fill="#acacac" />
                        </g>
                      </g>
                      <path id="Path_282" data-name="Path 282"
                        d="M91.277,247.3a1.577,1.577,0,1,0,1.577,1.577A1.69,1.69,0,0,0,91.277,247.3Z"
                        transform="translate(-77.694 -230.001)" fill="#acacac" />
                    </g>
                    <g id="FanOff" v-if="!tempControl.fan.off" transform="translate(1477 4345.349)">
                      <g id="Group_68-2" data-name="Group 68">
                        <path id="Path_171-2" data-name="Path 171"
                          d="M48.281,60.579s-.969-.436-.969.579a2.289,2.289,0,0,0,.974,1.691,6.068,6.068,0,1,1-6.46.005,2.306,2.306,0,0,0,.974-1.691c0-1.015-.969-.579-.969-.579a8.068,8.068,0,1,0,6.453-.005Z"
                          transform="translate(-36.998 -58.016)" fill="#acacac" />
                        <path id="Path_172-2" data-name="Path 172"
                          d="M172.685,12.3a1.074,1.074,0,0,0-1.185.912v8.047a1.074,1.074,0,0,0,1.185.912.948.948,0,0,0,1.072-.912V13.217A.949.949,0,0,0,172.685,12.3Z"
                          transform="translate(-164.57 -12.3)" fill="#acacac" />
                      </g>
                    </g>
                  </g>
                  <g id="Sched" transform="translate(-364 57)">
                    <g id="SchedSched" v-if="!tempControl.sched.schedule" transform="translate(1518 4329)">
                      <path id="Path_212" data-name="Path 212"
                        d="M153.892,227.936h-1.136v-.379a.757.757,0,0,0-1.515,0v.379h-7.385v-.379a.757.757,0,0,0-1.515,0v.379H141.2a1.7,1.7,0,0,0-1.7,1.7V241.95a1.7,1.7,0,0,0,1.7,1.7h12.309a1.7,1.7,0,0,0,1.7-1.7V229.641A1.416,1.416,0,0,0,153.892,227.936Zm-12.5,1.326h1.136v.379a.757.757,0,0,0,1.515,0v-.379h7.385v.379a.757.757,0,0,0,1.515,0v-.379h1.136a.185.185,0,0,1,.189.189v1.7H141.394v-1.7C141.2,229.451,141.2,229.262,141.394,229.262Zm12.5,13.067H141.583a.185.185,0,0,1-.189-.189V232.86h12.877v9.279A.661.661,0,0,0,153.892,242.329Z"
                        transform="translate(-139.5 -226.8)" fill="#acacac" />
                      <rect id="Rectangle_4" data-name="Rectangle 4" width="1.894" height="1.894"
                        transform="translate(2.841 7.007)" fill="#acacac" />
                      <rect id="Rectangle_5" data-name="Rectangle 5" width="1.894" height="1.894"
                        transform="translate(5.681 7.007)" fill="#acacac" />
                      <rect id="Rectangle_6" data-name="Rectangle 6" width="1.894" height="1.894"
                        transform="translate(8.711 7.007)" fill="#acacac" />
                      <rect id="Rectangle_7" data-name="Rectangle 7" width="1.894" height="1.894"
                        transform="translate(11.552 7.007)" fill="#acacac" />
                      <rect id="Rectangle_8" data-name="Rectangle 8" width="1.894" height="1.894"
                        transform="translate(2.841 9.848)" fill="#acacac" />
                      <rect id="Rectangle_9" data-name="Rectangle 9" width="1.894" height="1.894"
                        transform="translate(5.681 9.848)" fill="#acacac" />
                      <rect id="Rectangle_10" data-name="Rectangle 10" width="1.894" height="1.894"
                        transform="translate(8.711 9.848)" fill="#acacac" />
                      <rect id="Rectangle_11" data-name="Rectangle 11" width="1.894" height="1.894"
                        transform="translate(11.552 9.848)" fill="#acacac" />
                      <rect id="Rectangle_12" data-name="Rectangle 12" width="1.894" height="1.894"
                        transform="translate(2.841 12.499)" fill="#acacac" />
                      <rect id="Rectangle_13" data-name="Rectangle 13" width="1.894" height="1.894"
                        transform="translate(5.681 12.499)" fill="#acacac" />
                      <rect id="Rectangle_14" data-name="Rectangle 14" width="1.894" height="1.894"
                        transform="translate(8.711 12.499)" fill="#acacac" />
                      <rect id="Rectangle_15" data-name="Rectangle 15" width="1.894" height="1.894"
                        transform="translate(11.552 12.499)" fill="#acacac" />
                    </g>
                    <g id="SchedTimed" v-if="!tempControl.sched.temp" transform="translate(1518 4329)">
                      <path id="Path_295" data-name="Path 295"
                        d="M132.113,41.424a.741.741,0,0,1-.743-.743V38.653a.743.743,0,0,1,1.485,0v2.029A.75.75,0,0,1,132.113,41.424Z"
                        transform="translate(-122.472 -27.74)" fill="#acacac" />
                      <path id="Path_297" data-name="Path 297"
                        d="M129.594,47.027a1.763,1.763,0,0,1-1.764-1.764V41.246l.159-.013a4.037,4.037,0,0,0,1.114-.212l.225-.08v4.323a.266.266,0,0,0,.265.265h7.346a.266.266,0,0,0,.265-.265V38.992a.266.266,0,0,0-.265-.265h-5.5l.066-.212a3.987,3.987,0,0,0,.186-1.114v-.159h4.164v-2.93a2.572,2.572,0,0,0-5.145,0v.5l-.278-.252a3.731,3.731,0,0,0-1.061-.69l-.119-.053.013-.133a4.028,4.028,0,0,1,4-3.448,4.08,4.08,0,0,1,4.071,4.071v3.01A1.74,1.74,0,0,1,138.7,39v6.272a1.763,1.763,0,0,1-1.764,1.764h-7.346Z"
                        transform="translate(-123.627 -30.24)" fill="#acacac" />
                      <g id="Group_394" data-name="Group 394" transform="translate(0 2.97)">
                        <path id="Path_299" data-name="Path 299"
                          d="M128.863,40.887a4.2,4.2,0,1,1,4.2-4.2A4.2,4.2,0,0,1,128.863,40.887Zm0-7.081a2.877,2.877,0,1,0,2.877,2.877A2.883,2.883,0,0,0,128.863,33.806Z"
                          transform="translate(-124.66 -32.48)" fill="#acacac" />
                      </g>
                      <g id="Group_395" data-name="Group 395" transform="translate(3.434 4.734)">
                        <path id="Path_300" data-name="Path 300"
                          d="M129.212,38.265a.622.622,0,0,1-.464-.2l-1.5-1.5v-2.1a.663.663,0,0,1,1.326,0v1.551l1.1,1.1a.656.656,0,0,1,0,.941A.622.622,0,0,1,129.212,38.265Z"
                          transform="translate(-127.25 -33.81)" fill="#acacac" />
                      </g>
                    </g>
                    <g id="SchedHold" transform="translate(1518 4329)">
                      <path id="Path_293" data-name="Path 293"
                        d="M47.945,47.522a1.814,1.814,0,0,1-1.815-1.815V39.251a1.791,1.791,0,0,1,1.406-1.733v-3.1a4.19,4.19,0,0,1,8.38,0v3.1a1.791,1.791,0,0,1,1.406,1.733v6.455a1.814,1.814,0,0,1-1.815,1.815Zm0-8.53a.274.274,0,0,0-.273.273V45.72a.274.274,0,0,0,.273.273h7.561a.274.274,0,0,0,.273-.273V39.265a.274.274,0,0,0-.273-.273Zm6.428-1.529V34.447a2.648,2.648,0,0,0-5.3,0v3.016Zm-2.661,6.865a.763.763,0,0,1-.764-.764V41.476a.764.764,0,0,1,1.529,0v2.088A.763.763,0,0,1,51.712,44.328Z"
                        transform="translate(-46.13 -30.23)" fill="#acacac" />
                    </g>
                    <g id="SchedVacation" v-if="!tempControl.sched.vacation" transform="translate(7700.751 8312.314)">
                      <path id="Path_306" data-name="Path 306"
                        d="M15.932,3.951c.737-.737,1.717-2.545.723-3.538-.919-.92-2.681-.167-3.509.676L10.992,2.927a1.568,1.568,0,0,1-1.355.422L9.351,3.3l.03-.03a.565.565,0,0,0-.8-.8l-.6.6L6.2,2.776l.09-.09a.555.555,0,0,0,0-.8.568.568,0,0,0-.8-.014l-.647.663L2.784,2.176a.6.6,0,0,0-.5.166L1.9,2.731a.57.57,0,0,0-.151.482.58.58,0,0,0,.3.422L7.559,6.421,4.246,10.065c-.2.181-.482.512-.663.723l-3.042.09a.566.566,0,0,0-.512.405.55.55,0,0,0,.211.618l1.988,1.416a9.98,9.98,0,0,0-.541,1.371.562.562,0,0,0,.783.663l1.19-.587,1.416,1.988a.578.578,0,0,0,.467.241.324.324,0,0,0,.166-.03.582.582,0,0,0,.405-.512l.12-2.937c.226-.2.572-.512.737-.678l3.675-3.313,2.786,5.512a.558.558,0,0,0,.888.151l.422-.423a.518.518,0,0,0,.151-.5L14.516,12.1l.587-.587a.565.565,0,1,0-.8-.8l-.015.015-.315-1.778.542-.542a.555.555,0,0,0,0-.8.564.564,0,0,0-.783,0l-.015-.181a1.6,1.6,0,0,1,.452-1.4Zm-2.59,1.327a2.73,2.73,0,0,0-.753,2.364l.858,4.955L11.324,8.348a.565.565,0,0,0-.405-.3.574.574,0,0,0-.482.136l-4.248,3.84c-.241.241-.888.783-.888.783a.614.614,0,0,0-.2.405l-.06,1.551-.753-1.039a.572.572,0,0,0-.452-.241.532.532,0,0,0-.256.06l-.271.136.12-.271a.562.562,0,0,0-.166-.723l-1.024-.721,1.642-.06a.507.507,0,0,0,.405-.2s.482-.572.753-.858l3.84-4.217a.574.574,0,0,0,.136-.482.555.555,0,0,0-.3-.405l-4.2-2.123,4.925.843a2.653,2.653,0,0,0,2.319-.723L13.9,1.919c.6-.589,1.673-.98,1.944-.708.286.286-.105,1.327-.753,1.973Z"
                        transform="translate(-6183.493 -3982.307)" fill="#acacac" />
                    </g>
                  </g>
                </g>
              </g>
            </svg>




          </b-col>

          <b-col order-sm="3" order-md="4" order-lg="3" col cols="12" md="8" class="small-title">
            <h3 data-aos="fade-left" class="increaseheading">Taking sales from cool to hot. <span>24% increase in sales.
              </span></h3>

            <div data-aos="fade-left">
              <b-row class="salesincrease">
                <b-col class="ab">
                  <p>24%</p>
                </b-col>
                <b-col class="ba"><img class="arrow" src="@/assets/images/universe/increase-arrow.svg"
                    alt="Percentage Increase Arrow">
                  <br>
                  <p><span class="increase">increase </span> <br class="md-up"><span class="insales">in sales</span></p>
                </b-col>
              </b-row>
            </div>
          </b-col>


          <b-col class="centercontent content" order-sm="4" order-md="3" order-lg="2" col cols="12" md="6" lg="6"
            xl="6">
            <div data-aos="fade-left">
              <h3 class="large-title">A simplified interface that users &nbsp;

                <svg class="heart" width="20" height="20" viewBox="0 0 100 100">
                  <path fill="tomato"
                    d="M92.71,7.27L92.71,7.27c-9.71-9.69-25.46-9.69-35.18,0L50,14.79l-7.54-7.52C32.75-2.42,17-2.42,7.29,7.27v0 c-9.71,9.69-9.71,25.41,0,35.1L50,85l42.71-42.63C102.43,32.68,102.43,16.96,92.71,7.27z">
                  </path>
                  <animateTransform attributeName="transform" type="scale" values="1; 1.5; 1.25; 1.5; 1.5; 1;" dur="1s"
                    repeatCount="indefinite">
                  </animateTransform>
                </svg>

              </h3>

              <p>Through promotion and trials, users of the app spread the
                word and shared their positive experiences and feedback. As
                use increased, a measurable increase in sales correlated with
                the data, indicating that Universe was directly responsible for
                heating up sales.</p>
              <p>With the information gathered, we began adding new features
                related to the maintenance and efficiency of Unilux VFC
                systems, helping them to last longer and save home owners
                money.</p>

              <div class="large-title">
                <h3 class="increaseheading">Taking sales from cool to hot. <span>24% increase in sales. </span></h3>

                <b-row class="salesincrease" >
                  <b-col class="ab">
                    <div class='boxNumber'></div>
                    <p>
                      <animated-number v-in-viewport="log_one" :value="value" :formatValue="formatToPrice" :duration="3000" :delay="500" />
                    </p>
                  </b-col>
                  <b-col class="ba"><img class="arrow" src="@/assets/images/universe/increase-arrow.svg"
                      alt="Percentage Increase Arrow">
                    <br>
                    <p><span class="increase">increase </span> <br class="md-up"><span class="insales">in sales</span>
                    </p>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>


        <b-row class="on-the-go justify-content-end">

          <b-col col cols="12" md="4" lg="6" order-sm="1" order-md="2">
            <!-- <b-img fluid class="handphone" :src="require(`../../assets/images/universe/universe-phone.png`)"></b-img> -->

            <b-img fluid class="handphone mobile" :src="require(`../../assets/images/universe/universe-phone.png`)">
            </b-img>
            <b-img fluid class="handphone desktop" :src="require(`../../assets/images/universe/handwithphone.png`)">
            </b-img>

          </b-col>


          <b-col class="content-container" order-sm="2" order-md="1" col cols="12" md="7" lg="5" xl="4">
            <div data-aos="fade-right">
              <h3>Home comfort on the go.</h3>
              <p>Our web-based software enables users to log into their account from a laptop, tablet, or mobile device.

</p>
              <p>Internal sensors send information to the unit controller identifying specific alarm conditions
                such as High or Low Space Temperatures and Drain Pan Overflow. An email is sent to the user when these
                alarms occur. A monthly email is also sent to the user providing energy usage based data on run time
                statistics.
              </p>

            </div>
          </b-col>
        </b-row>


      </b-row>


    </b-container>

    </div>

  
                       
        <!-- <div class="slide project-preview-container section-animation-in" :class="{ 'section-animation-in': hover }" id="slide1" data-project="1">

          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span class="otherprojecthead">A Fast Way to Find your Flavour.</span></div>
                <div class="text-row"><span class="changeme">Thousands of displays ready to order.</span></div>
              </h2>

              <router-link to="/work/prepack-planner" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492"
                        style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div> -->

   

        <div class="container-fluid otherwork" :class="{ 'section-animation-in': hover }">

          <h4>See work <span>that matters.</span></h4>

<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[0] }">
<div class="image-container">
    <div class="divide"></div>
    <router-link to="/work/winning" class="content">
      <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
      <span class="otherprojecthead">3M Electrical</span>
      <span class="changeme">Uncover the secret.</span>
</router-link>

  <img class="fade-in-image" :src="require(`../../assets/images/winning-other.png`)" alt="Your image">
</div>
</div>


<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[1] }">
<div class="image-container">
    <div class="divide"></div>
    <router-link to="/work/clarity" class="content">
      <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
     <span class="otherprojecthead">3M Clarity</span>
     <span class="changeme">Smiles for miles.</span>
</router-link>

  <img class="fade-in-image" :src="require(`../../assets/images/clarity-other.png`)" alt="Your image">
</div>
</div>

<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[2] }">
  <div class="image-container">
      <div class="divide"></div>
      <router-link to="/work/surface" class="content">     
        <span class="projecttype dark">CAMPAIGN DEVELOPMENT</span>
         <span class="otherprojecthead dark">3M Food Safety</span>
         <span class="changem dark">See beyond the surface.</span>
    </router-link>
  
    <img class="fade-in-image" :src="require(`../../assets/images/surface-other.png`)" alt="Your image">
  </div>
  </div>



<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[3] }">
<div class="image-container">
    <div class="divide"></div>
    <router-link to="/work/higher" class="content">  
      <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
      <span class="otherprojecthead">3M Fall Protection</span>
     <span class="changeme">Bottom lines to new heights.</span>

</router-link>
  <img class="fade-in-image" :src="require(`../../assets/images/higher-other.png`)" alt="Your image">
</div>
</div>


<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[4] }">
<div class="image-container">
    <div class="divide"></div>
    <router-link to="/work/prepack-planner" class="content">      
      <span class="projecttype">APP DEVELOPMENT</span>
      <span class="otherprojecthead">McCormick Display Strategy</span>
     <span class="changeme">Displays to order.</span>
</router-link>

  <img class="fade-in-image" :src="require(`../../assets/images/prepack-other.png`)" alt="Your image">
</div>
</div>

          </div>

    


  </section>



</template>

<script>
  import Parallax from 'vue-parallaxy'
  import AnimatedNumber from "animated-number-vue";
  import InViewport from 'v-in-viewport';

  //AOS Animations
  import AOS from 'aos';
  import 'aos/dist/aos.css';


  export default {
    components: {
      Parallax,
      AnimatedNumber
      
    },
        directives: {
        InViewport
    },
    data() {
      return {
        hover: false,
        ready: false,
        blurheadline: false,
        value: 0,
        numberReady: false,
        inview: false,
        isBottom: true,
        sendUpdate: false,
        stopUpdate: false,
        isActive: false,
        activeStates: {},
        currentDevice: {
          data: {
            temperature: '',
            humidity: ''
          },
          online_settings: {
            units: 0,
            timezone: '',
            country: '',
            zip: ''
          },
          online_config: {
            hold_temp: {
              celsius: '',
              fahrenheit: ''
            }
          }
        },
        tempControl: {
          mode: {
            heat: true,
            cool: true,
            auto: true,
            off: true,
            setting: ''
          },
          fan: {
            high: true,
            med: true,
            low: true,
            auto: true,
            off: true,
            setting: ''
          },
          sched: {
            hold: true,
            temp: true,
            schedule: true,
            vacation: true,
            setting: ''
          },
          hold_temp: {
            celsius: 22,
            fahrenheit: ''
          },
          outdoor_temp: ''
        },
        tempdownPressed: false,
        tempupPressed: false,
        interval: false,
        holdtemp_decimal: false,
        indoortemp_decimal: false,
        count: 0,
        tempTimeout: false,

      };
    },
    metaInfo: {
      titleTemplate: 'Control Your Universe | Branton  — a Creation Company.',
      meta: [{
        name: "Universe Mobile Application",
        content: "Unilux VFC manufactures heating and cooling systems for today’s high-rise condos. With the rising demand for home owners to control their systems remotely, Unilux VFC put the ball in our court to design and develop a solution with a cool look that customers can warm up to. Introducing Universe."
      }]
    },
    methods: {

      initializeObservers() {
  const elements = this.$el.querySelectorAll('.preview-text-container');
  if (elements.length === 0) {
    console.error('No elements found');
    return;
  }
  elements.forEach((element, index) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        console.log(`Element ${index} is intersecting: ${entry.isIntersecting}`);
        this.$set(this.activeStates, index, entry.isIntersecting);
      });
    }, { threshold: 1 });

    observer.observe(element);
  });
},

          log_one () {
            this.value = 24;
        },
    
      handleScroll() {
        if (window.scrollY > 200) {
          this.blurheadline = true;
        } else {
          this.blurheadline = false;
        }
      },

      start(direction) {
        const self = this;
        self.stopUpdate = true;
        if (!self.tempControl.sched.schedule) {
          self.tempControl.sched.schedule = true
          self.tempControl.sched.temp = false
          self.tempControl.sched.setting = "temp"
        }

        if (!self.interval) {
          if (direction == 'up') {
            self.tempupPressed = true;
          }
          if (direction == 'down') {
            self.tempdownPressed = true;
          }
          self.holdtemp(direction)
          self.interval = setInterval(function () {
            self.holdtemp(direction)
          }, 300)
        }
        clearTimeout(self.tempTimeout);
      },
      stop() {
        const self = this;
        clearInterval(self.interval)
        self.interval = false
        self.tempupPressed = false;
        self.tempdownPressed = false;

        self.tempTimeout = setTimeout(function () {
          self.sendUpdate = true;
        }, 3500);

      },

      holdtemp: function (direction) {
        //CHECK MIN AND MAX
        const self = this;
        if (direction == 'up') {
          if (this.currentDevice.online_settings.units == 0) {
            if (self.tempControl.hold_temp.celsius < 30) {
              self.tempControl.hold_temp.celsius = self.tempControl.hold_temp.celsius + 0.5
            }
          } else {
            if (self.tempControl.hold_temp.fahrenheit < 86) {
              self.tempControl.hold_temp.fahrenheit = self.tempControl.hold_temp.fahrenheit + 1
            }
          }
        }
        if (direction == 'down') {
          if (this.currentDevice.online_settings.units == 0) {
            if (self.tempControl.hold_temp.celsius > 12) {
              self.tempControl.hold_temp.celsius = self.tempControl.hold_temp.celsius - 0.5
            }
          } else {
            if (self.tempControl.hold_temp.fahrenheit > 56) {
              self.tempControl.hold_temp.fahrenheit = self.tempControl.hold_temp.fahrenheit - 1
            }
          }
        }
      },
      tempCalculatorwithFormat: function (measurement, rating, temp) {
        const self = this;
        measurement = Number(measurement);
        rating = Number(rating);

        if (measurement == 1) {
          self[temp] = false;
          return rating;
        } else {
          var split = rating.toString().split('.');
          if (split[1]) {
            self[temp] = true;
            return `${split[0]}`;
          } else {
            self[temp] = false;
            return `${split[0]}`;
          }
        }
      },
      formatToPrice(value) {
        return `${value.toFixed(0)}%`;
      },
      toggleActive(event) {
      event.currentTarget.classList.toggle('active');
    },
    },
    mounted() {
      this.$nextTick(() => {
    this.initializeObservers();
  });

      this.ready = true;

   this.$gtag.pageview({
        page_path: '/work/universe',
      })

      if (this.ready) {
        AOS.init();
        AOS.refresh();
        setTimeout(function () {
          AOS.refresh();
        }.bind(this), 300)
      }

  // console.log('TEST');

    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },

  }
</script>


<style lang="scss">
  @import '@/assets/css/universe.scss';



</style>